import React from "react";
import { ExternalLink } from "react-feather";
import { CloseIcon } from "../../atoms/CloseIcon";
import {
  Body,
  CardOuter,
  DismissButton,
  ExternalIconWrapper,
  HighlightLink,
  LinkRow,
  Separator,
} from "./SidebarPromoCard.styles";
import type { SidebarPromoCardProps } from "./SidebarPromoCard.types";

/** Sidebar promo callout — "Capture with MagicBI" / install-or-update the Chrome extension. */
export const SidebarPromoCard: React.FC<SidebarPromoCardProps> = ({
  onDismiss,
  onAddToChrome,
  onUpdate,
}) => (
  <CardOuter role="note">
    <DismissButton type="button" aria-label="Dismiss" onClick={onDismiss}>
      <CloseIcon size={16} />
    </DismissButton>
    <Body>Capture with MagicBI</Body>
    <LinkRow>
      <HighlightLink type="button" onClick={onAddToChrome}>
        Add to Chrome
      </HighlightLink>
      <Separator>or</Separator>
      <HighlightLink type="button" onClick={onUpdate}>
        update
      </HighlightLink>
      <ExternalIconWrapper aria-hidden="true">
        <ExternalLink size={16} />
      </ExternalIconWrapper>
    </LinkRow>
  </CardOuter>
);

export default SidebarPromoCard;
